import * as apis from "@/api";
import { conversion, GetItemDuration } from "@/tool";
import { mapState, mapMutations } from "vuex";
import Award from "@/components/UI/award";
import Number from "@/components/AnimateNumber";
import UnpackgameInstanceItem from "@/components/UnpackgameInstanceItem";

export default {
  components: {
    "c-award": Award,
    "c-number": Number,
    "c-unpackgameInstance-item": UnpackgameInstanceItem,
  },
  data() {
    return {
      isShow: false,
      case_opened_awards: [],
      garbageAwardList: [],
      bgPos: 0,
      gameInstance_info: {},
      unpackgameInstance_item_show: false,
      awardsConvertList: [],
    };
  },
  props: {
    isMyself: {
      type: Boolean,
      default: true,
    },
  },

  filters: {
    conversion,
    GetItemDuration,
  },
  computed: {
    ...mapState(["sellSound", "isMute"]),
    /** 开箱结果奖品金额合计 */
    case_opened_awards_amount: (vm) =>
      vm.case_opened_awards
        .filter((_) => !_.isConvert)
        .reduce((acc, { price }) => acc + price, 0),
  },
  watch: {
    case_opened_awards: {
      handler(val) {
        this.awardsConvertList = val.filter((_) => _.isConvert);
      },
      deep: true,
      immediate: true,
    },
    isShow(val){
      if(!val){
        this.$emit('onCloseRewardHandle')
      }
    },
  },
  methods: {
    reset() {
      if (this.isMyself) {
        //凉凉奖励必须售出
        this.case_opened_awards.forEach((case_item) => {
          if (!case_item.isConvert) {
            //售出
            this.case_opened_awards_discount(case_item);
          }
        });
      }
      this.case_opened_awards = [];
      this.garbageAwardList = [];
      this.isShow = false;
    },
    pushItem(
      name,
      mSerial,
      itempic,
      rarity,
      price,
      isConvert,
      roll,
      isGarbageAward,
      awardPlayerName
    ) {
      var typename = name.match(/^(.*?)\s?(\(.*\))?$/)[1];
      var skinname = "";
      var dur = GetItemDuration(name);
      var strArr = typename.split("|");
      if (strArr.length > 1) {
        typename = strArr[0];
        skinname = strArr[1];
      }
      let case_opened_awards_item = {
        name: name,
        typename,
        skinname,
        dur,
        mSerial,
        itempic,
        rarity,
        price,
        isConvert,
        roll,
        isGarbageAward,
        awardPlayerName,
      };
      this.case_opened_awards.push(case_opened_awards_item);
      if (isGarbageAward) {
        this.garbageAwardList.push(case_opened_awards_item);
      }
    },
    async show() {
      this.bgPos = Math.floor(Math.random() * 100) % 3;
      this.isShow = true;
    },
    /** 开箱奖品折现 */
    async case_opened_awards_discount(award) {
      var awards_Serial = this.case_opened_awards
        .filter((_) => !_.isConvert)
        .map((award) => award.mSerial);

      if (award) {
        awards_Serial = [award.mSerial];
      }

      const awards_discount_response = await apis.api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      this.$toast.success(awards_discount_response.data.msg, {
        timeout: 2000,
      });

      // 更新用户信息
      this.$store.commit("setInfo");

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.isConvert = true;
        }
      });

      if (this.case_opened_awards_amount <= 0) {
        this.reset();
      }
    },
  },
};
